export const iconFontAwesomeShoppingGoogleWallet = (
	<i className="fa-solid fa-google-wallet"></i>
);
